export const cutString = (string, length) => {
    if (string?.length > length) {
      return string.slice(0, length - 3) + '...'
    } else {
      return string
    }
  }